import { ApiFindPatentFolders } from '@/infrastructure/api-functions/api-find-patent-folders';
import { WorkspaceApiServiceImpl } from '@/infrastructure/api-functions/workspace-api-service';
import { PatentFoldersServiceImp, WORKSPACE_URI } from '@/modules/patent-folders-module/patent-folders-service';
import { PatentFoldersService } from '@/modules/patent-folders-module/patent-folders-service.interface';
import { WORKSPACE_URI as workspaceUri } from '@cores/constants/envConfig';
import { ApiShortQuery } from '@/infrastructure/api-functions/api-short-query.interface';
import { FilterPatentInFolderService } from './filter-patent-in-folder-service.interface';
import { FilterPatentInFolderServiceImpl } from './filter-patent-in-folder-service';
export function patentFoldersModule(bind) {
    bind(WORKSPACE_URI).toConstantValue(workspaceUri);
    bind(PatentFoldersService).to(PatentFoldersServiceImp);
    bind(ApiShortQuery).to(WorkspaceApiServiceImpl);
    bind(ApiFindPatentFolders).to(WorkspaceApiServiceImpl);
    bind(FilterPatentInFolderService).to(FilterPatentInFolderServiceImpl);
}
